var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcQuizzesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.25 9.49)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.417,
    cy: 3.451,
    rx: 1.417,
    ry: 1.294
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.945,
    width: 1,
    height: 3.02,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.147 3.573v-.985H7.63A1.294 1.294 0 1 1 7.63 0h4.654a1.294 1.294 0 0 1 0 2.588h-.517v1.066c4.397.893 7.695 4.615 7.695 9.071 0 5.123-4.357 9.275-9.731 9.275S0 17.848 0 12.725c0-4.608 3.526-8.43 8.147-9.152ZM9.73 19.412c3.874 0 7.015-2.994 7.015-6.687 0-3.692-3.14-6.686-7.015-6.686-3.875 0-7.015 2.994-7.015 6.686 0 3.693 3.14 6.687 7.015 6.687Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuizzesWhite);
export default __webpack_public_path__ + "static/media/ic-quizzes-white.ac5d2b96a756cc855d823bf70f24ae18.svg";
export { ForwardRef as ReactComponent };